import { ApiProperty } from "@nestjs/swagger";


export class BloodDonationUserRequest {
    @ApiProperty()
    username: string;
    @ApiProperty()
    phone: string;
    @ApiProperty()
    uniqueId: string;
    @ApiProperty()
    constituency: string;
    @ApiProperty()
    date: string; 
}